import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const PriceDefaultProps = {
  ...ClassNameDefaultProps,
  context: null,
  currency: '€',
  emptyLabel: null,
  sup: true,
  type: null,
  typeSup: false,
  unit: null,
  value: null,
};

export const PricePropTypes = {
  ...ClassNamePropTypes,
  context: PropTypes.string,
  currency: PropTypes.string,
  emptyLabel: PropTypes.string,
  sup: PropTypes.bool,
  type: PropTypes.string,
  typeSup: PropTypes.bool,
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
